import { Component, HostListener, Inject, Input } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { first } from 'rxjs';
import { FadeInOut } from 'src/app/animations/FadeInOut';

@Component({
	selector: 'app-image-dialog',
	templateUrl: './image-dialog.component.html',
	styleUrls: ['./image-dialog.component.scss'],
	animations: [FadeInOut]
})
export class ImageDialogComponent {

	images! : string[];
	selectedIndex! : number;
	showButtons = false;

	@HostListener('document:keydown.ArrowRight') next() {
		if (this.selectedIndex < this.images.length-1)
			this.selectedIndex++;
	}
	@HostListener('document:keydown.ArrowLeft') previous() {
		if (this.selectedIndex > 0)
			this.selectedIndex--;
	}
	@HostListener("wheel", ["$event"]) onMouseWheel($event:WheelEvent) {
		if ($event.deltaY > 0) {
			this.next();
		} else if ($event.deltaY < 0) {
			this.previous();
		}
	}

	constructor(private selfDialogRef: MatDialogRef<ImageDialogComponent>) {
		this.selfDialogRef.afterOpened().pipe(first()).subscribe(()=> {
			setTimeout(() => {
				this.showButtons = true;
			}, 20);
		});
	}

	set(imageOrImages:string|string[], startingIndex?:number) {
		if (typeof(imageOrImages) == "string")
			this.images = [imageOrImages];
		else
			this.images = imageOrImages;
		
		if (startingIndex != undefined)
			this.selectedIndex = startingIndex;
		else
			this.selectedIndex = 0;
	}
}
